<template>
  <div>
    <mu-appbar title="產品列表">
    </mu-appbar>
    <mu-content-block>
      <div class="demo-grid">
        <mu-row gutter>
          <mu-col width="0" tablet="0" desktop="20">
          </mu-col>
          <mu-col width="100" tablet="50" desktop="30">
            <mu-text-field label="物品名稱" type="text" errorText="不可空白" labelFloat v-model="title" /><br/>
            <mu-text-field label="價格" type="number" errorText="不可空白" labelFloat v-model="price" /><br/>
            <mu-text-field label="地點" type="text" hintText="如：台北市大安區" labelFloat v-model="address"/><br/>
            <mu-text-field hintText="(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色" multiLine :rows="4" v-model="description"/><br/>
            <mu-text-field label="關鍵字" type="text" hintText="逗點分隔關鍵字，如：nike,puma..." labelFloat v-model="keywords" /><br/>

          </mu-col>
          <mu-col width="100" tablet="50" desktop="30">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title :title="title" :subTitle="' NT$' + price"/>
              <mu-card-text class="text-align-left">
                地點：{{address}}
                <pre>{{description}}</pre>
              </mu-card-text>
              <mu-card-text class="text-align-left">
                <div v-for="keyword in splitArray">
                  <span><a :href="'#'+keyword">#{{keyword}}</a></span>
                </div>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="丟訊息問問 Wu Yi-Ju" />
              </mu-card-actions>
            </mu-card>
          </mu-col>
          <mu-col width="0" tablet="0" desktop="20">
          </mu-col>
        </mu-row>
      </div>
    </mu-content-block>

    <mu-content-block>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <h1>所有物品</h1>
          </mu-col>
        </mu-row>
    <div class="demo-grid">
      <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                使用一切正常，意者自取<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break linesasdhfaioshdfliuahsdlifuhIGWRUHIRAUHGAILERUHGLIRAUEHGLIERUHFASDFHASODFHOADS within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                使用一切正常，意者自取<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
                    <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
                    <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                使用一切正常，意者自取<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
                    <mu-col width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img :src="img" />
              </mu-card-media>
              <mu-card-title title="櫃子 $ 500" subTitle="地點：台北縣新莊區"/>
              <mu-card-text class="text-align-left">
                狀況：二手<br />
                尺寸：140x180x41 cm<br />
                顏色：白色<br />
                使用一切正常，意者自取<br />
                <span><a href="#">#aa</a></span>
                <span><a href="#">#bb</a></span>
              </mu-card-text>
              <mu-card-header  title="5小時前 建立" subTitle="來自 Wu Yi-Ju">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="詢問" />
              </mu-card-actions>
                            <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
            </mu-card>
          </mu-col>
        </mu-row>
    </div>
    </mu-content-block>
  </div>
</template>
<script>
import img from './assets/images/sun.jpg'
import myron from './assets/images/uicon.jpg'
export default {
  data () {
    return {
      title: '',
      price: NaN,
      address: '',
      description: '',
      keywords: '',
      img,
      myron
    }
  },
  computed: {
    splitArray () {
      return this.keywords.split(',')
    }
  }
}
</script>
<style lang="css">
.demo-grid div[class*="col-"] {
  background: #fff;
  color: #000;
  padding: 8px;
  margin-bottom: 8px;
  margin-left:auto;
  margin-right:auto;
}
.text-align-left {
  text-align: left;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// Example.vue?bcc99a9e